
import { useAuth } from "@/contexts/auth";
import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import LoadingSpinner from "@/components/LoadingSpinner";

interface ProtectedRouteProps {
  children: ReactNode;
  adminOnly?: boolean;
}

const ProtectedRoute = ({ children, adminOnly = false }: ProtectedRouteProps) => {
  const { user, loading, isAdmin, isAdminLoading } = useAuth();

  if (loading || (adminOnly && user && isAdminLoading)) {
    return <div className="py-12"><LoadingSpinner /></div>;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
